import { gql } from 'graphql-request';
import useSWRMutation from 'swr/mutation';
import { BasketFragment } from '@graphql/fragments';
import { basketRequest, BasketRequestProps } from '@hooks/basket/_utils';
import { formatBasket, useBasketMutation } from '@hooks/basket/useBasket';
import { useCustomerIdToken } from '@hooks/customer';
import useCurrentUrl from '@repo/ui/src/hooks/useCurrentUrl';

export const applyCouponToBasket = gql`
  ${BasketFragment}
  mutation ApplyCouponToBasket($couponCode: String!) {
    applyCouponToBasket(couponCode: $couponCode) {
      ...Basket
    }
  }
`;

interface Key extends BasketRequestProps {
  locale: string;
}

const fetcher = async (key: Key, { arg: couponCode }: { arg: string }) => {
  const { applyCouponToBasket: basket } = await basketRequest({
    ...key,
    variables: {
      couponCode,
    },
  });
  return basket;
};

export const useApplyCouponToBasket = () => {
  const { locale, country } = useCurrentUrl();
  const idToken = useCustomerIdToken();
  const mutate = useBasketMutation();

  return useSWRMutation(
    {
      document: applyCouponToBasket,
      locale,
      idToken,
      country,
    },
    fetcher,
    {
      onSuccess: async (basket) => {
        const formattedBasket = formatBasket(basket, locale);
        await mutate(formattedBasket, { revalidate: false });
      },
    },
  );
};
